import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./index.css";

//Imports from Redux --------------
import {
  schedulesInternalTxnApproval,
  schedulesInternalTxnReject,
  scheduleInternalTxnOccurrences,
  scheduleInternalTxnView,
} from "../../../redux/features/scheduleInternalTxn/index.js";
import {
  getOwnerAccBalance,
  setshowsuccestoast,
} from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { toast_position } from "../../../redux/features/Settings/Authorization/index.js";
import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN.js";
import { ViewAllAccountInternal } from "../../../redux/features/InternalAccount/ViewAllAccountInternal.js";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

//Imports from Components --------------
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import BeneTxnDataFormat from "../../../utils/BeneTxnDataFormat.js";
import { formatTime } from "../../../utils/formatTime.js";
import Loader from "../../../components/Loader/Index";
import InternalAccDetailsPopUp from "../../../components/Accounts/InternalAccDetailPopup/index.jsx";
import ScheduleInternalTxnDetailPopup from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnDetailPopup/index.jsx";
import CommonTransactionApprovalCard from "../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import InternalScheduleTxnDeclinePopup from "../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalScheduleTxnDeclinePopup.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast/index.jsx";
import ScheduleTxnOccurrencesPopup from "../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup/index.jsx";
import ICONS from "../../../assets/Icons/index.js";

const ApprovalGreen = ICONS.APPROVED_GREEN_LINEAR;
const ConfidentialIcon = ICONS.CONFIDENTIAL_TRANSACTION;
const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

const ScheduleInternalTransactionSingleApproval = () => {
  //Variables ---------------
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //Refs ---------------
  const filterRef = useRef(null);
  const scrollRef = useRef(null);

  //Selectors
  const [wasActionLoading, setWasActionLoading] = useState(false);
  const services = useSelector((state) => state.refreshToken.services);
  const {
    schedulesInternalTxnRejectLoading,
    schedulesInternalTxnApprovalLoading,
    schedulesInternalTxnViewAllLoading,
  } = useSelector((state) => state.scheduleInternalTxnSlice);
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  //States ---------------
  const [selectedPageValue, setSelectedPageValue] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [scheduleIntTxnLoading, setscheduleIntTxnLoading] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [formatedData, setFormatedData] = useState([]);
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [scheduleId, setScheduleId] = useState("");
  const [occurrenceData, setOccurrenceData] = useState([]);
  const [openOccurrencePopup, setOpenOccurrencePopup] = useState(false);
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [PrevBalance, setPrevBalance] = useState(null);
  const [refreshId, SetrefreshId] = useState("");
  const [internalAccDetailPopOpen, setInternalAccDetailPopOpen] =
    useState(false);
  const [internalAccId, setInternalAccId] = useState("");
  const [internalScheduleId, setInternalScheduleId] = useState("");
  const [isAdditionalPopupOpen, setIsAdditionalPopupOpen] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [searchdata, SetsearchData] = useState("");
  const [initCategoryFilter, setInitCategoryFilter] = useState("");
  const hasOccurrenceService = services?.includes("IOScheduledTxn");

  const InternalIcon =
    "https://q2pay.in/new_assets/common/detail_page/internal_with_white_circle.svg";

  const DeclinedRed =
    "https://q2pay.in/new_assets/common/approval/rejected_red.svg";
  //filters states
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",

    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [filterPayload, setFilterPayload] = useState({
    pagination: GlobalConfiguration.lengthCheckZero,
    accNoInput: "",
    currentPage: GlobalConfiguration.lengthCheckOne,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    beneAccountSearch: "",
    searchTerm: "",
  });

  const [hideCarousal, setHideCaroursal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [accountModalSearch, setAccountModalSearch] = useState(false);

  const [IFSC, setIFSC] = useState("");
  const [bankLogo, setBankLogo] = useState("");
  const [amountInWords, setAmountInWords] = useState("");
  const [category, setCategory] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [panNumber, setPanNumber] = useState(null);
  const [IFSC1, setIFSC1] = useState("");
  const [bankLogo1, setBankLogo1] = useState("");
  const [beneAccountId, setBeneAccountId] = useState(null);

  const [FrequencyMethod, setFrequencyMethod] = useState("");
  const [frequencyMethodfilter, setFrequencyMethodfilter] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  const [confidentialMethod, setConfidentialMethod] = useState("");
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState("");
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [ownerAccId, setOwnerAccId] = useState("");
  const [ownerAccNo, setOwnerAccNo] = useState("");
  const [internalAccNo, setInternalAccNo] = useState("");
  const [internalAccIdFilter, setInternalAccIdFilter] = useState("");

  const [approveRejectBtnClicked, setApproveRejectBtnClicked] = useState({});

  //sessionStorage
  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const formatDate = (date) => {
    const day = String(date.getDate())?.padStart(
      GlobalConfiguration.lengthCheckTwo,
      GlobalConfiguration.dashboardPrimaryCount,
    );
    const month = String(
      date.getMonth() + GlobalConfiguration.lengthCheckOne,
    )?.padStart(
      GlobalConfiguration.lengthCheckTwo,
      GlobalConfiguration.dashboardPrimaryCount,
    );
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatedTxnPeriod = (dateString) => {
    const d = new Date(dateString);
    const day = d.toLocaleDateString("en-GB", { day: "numeric" });
    const month = d.toLocaleDateString("en-GB", {
      month: "short",
    });
    const year = d.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      const search_string = String(searchUserTextDebounce || "").trim();
      if (!search_string) {
        data = [];
        return;
      }

      switch (active) {
        case "Internal account": {
          const numericOnly = search_string.replace(/\D/g, "");
          const internalParams =
            numericOnly.length >= GlobalConfiguration.accountminLength
              ? {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  bank_account_no: numericOnly,
                  type: "internalAccount",
                }
              : {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  search_string: search_string,
                  type: "internalAccount",
                };

          response = await dispatch(ViewAllAccountInternal(internalParams));

          data =
            response?.payload?.internal_accounts?.map((itm) => ({
              id: itm.id,
              display: itm.name
                ? `${itm.bank_acc_no || ""} - ${itm.name}`
                : itm.bank_acc_no || itm.id,
              bank_account_no: itm.bank_acc_no,
              name: itm.name,
              ifsc_code: itm.ifsc_code,
              email_id: itm.email_id,
            })) || [];

          break;
        }

        case "Owner account": {
          const numericOnlyOwn = search_string.replace(/\D/g, "");
          const ownerParams =
            numericOnlyOwn.length >= GlobalConfiguration.accountminLength
              ? {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  bank_account_no: numericOnlyOwn,
                }
              : {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  search_string: search_string,
                };

          response = await dispatch(ownerListViewAllAcc(ownerParams));
          data =
            response?.payload?.owner_accounts?.map((itm) => ({
              id: itm.id,
              display: itm.name
                ? `${itm.bank_acc_no || ""} - ${itm.name}`
                : itm.bank_acc_no || itm.id,
              bank_account_no: itm.bank_acc_no,
              name: itm.name,
              ifsc_code: itm.ifsc_code,
              email_id: itm.email_id,
            })) || [];
          break;
        }

        case "Category":
        case "search":
        case "Amount":
        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const handleAction = async () => {
    try {
      setscheduleIntTxnLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: selectedPageValue,
        lifecycle_status: "pending",
      };

      if (searchdata && searchdata !== "") {
        queryParams.scheduled_name = searchdata;
      }

      if (frequencyMethodfilter && frequencyMethodfilter !== "") {
        queryParams.frequency = frequencyMethodfilter;
      }

      if (initCategoryFilter && initCategoryFilter !== "") {
        queryParams.category = initCategoryFilter;
      }

      if (startDateFilter && startDateFilter !== "") {
        queryParams.transaction_start_date = formatDate(startDateFilter);
      }

      if (endDateFilter && endDateFilter !== "") {
        queryParams.transaction_end_date = formatDate(endDateFilter);
      }
      if (paymentMethodFilter && paymentMethodFilter !== "") {
        queryParams.payment_method = paymentMethodFilter;
      }
      if (confidentialMethodFilter && confidentialMethodFilter !== "") {
        queryParams.confidential_transaction = confidentialMethodFilter;
      }

      if (
        txnAmountFilter &&
        txnAmountFilter > GlobalConfiguration.lengthCheckZero
      ) {
        queryParams.amount = txnAmountFilter;
      }

      if (internalAccIdFilter && internalAccIdFilter !== "") {
        queryParams.internal_account_id = internalAccIdFilter;
      }

      if (ownerAccId && ownerAccId !== "") {
        queryParams.owner_account_id = ownerAccId;
      }

      const response = await dispatch(
        scheduleInternalTxnView(
          queryParams,
          // services,
        ),
      );
      const newData = response?.payload?.transactions || [];

      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTransactionData(response?.payload);
      setFormatedData(formattedData);

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
      );
    } catch (error) {
      console.error("Error in API call:", error);
      setTransactionData([]);
      setFormatedData([]);
    } finally {
      setscheduleIntTxnLoading(false);
    }
  };
  useEffect(() => {
    const isActionLoading =
      schedulesInternalTxnApprovalLoading || schedulesInternalTxnRejectLoading;
    if (isAdditionalPopupOpen && isActionLoading) {
      setWasActionLoading(true);
    } else if (isAdditionalPopupOpen && wasActionLoading && !isActionLoading) {
      setTimeout(() => {
        setIsAdditionalPopupOpen("");
        setWasActionLoading(false);
      }, IntervalConfiguration.intervalExtraLarge);
    }
  }, [
    schedulesInternalTxnApprovalLoading,
    schedulesInternalTxnRejectLoading,
    isAdditionalPopupOpen,
  ]);

  const handleTxnAction = async (id, reason = "", type) => {
    const isReject = type === "reject";
    const toastMsg = isReject ? "Rejecting schedule" : "Approving schedule";
    const reduxAction = isReject
      ? schedulesInternalTxnReject
      : schedulesInternalTxnApproval;

    setLoading((prev) => ({ ...prev, [id]: true }));
    setActionLoading(true);
    UniversalRefreshToast(toastMsg);

    const data = await dispatch(
      reduxAction({
        id,
        reason,
        services,
        navigate,
      }),
    );

    let errorMessage = "";
    let lifecycleStatus = "";

    const payload = data?.payload;

    if (payload?.status === errorcode.errorFailed) {
      lifecycleStatus = "pending";
      setTimeout(
        () =>
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          }),
        IntervalConfiguration.intervalExtraLarger,
      );
    }

    if (
      payload?.errors?.user_unauthorized?.[GlobalConfiguration.lengthCheckZero]
    ) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "VBeneficiaryTxn" },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      return;
    }

    if (payload?.status !== errorcode.errorNotFound) {
      const updatedData = formatedData?.map((item) => {
        if (item.txn_id === id) {
          const txn =
            payload?.transactions?.[GlobalConfiguration.lengthCheckZero];
          const isSuccess = payload?.status === true;
          const isLifecycleMatch = isReject
            ? txn?.lifecycle_status === "rejected"
            : txn?.lifecycle_status === "approved";

          if (isSuccess && isLifecycleMatch) {
            lifecycleStatus = txn.lifecycle_status;
          } else if (
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]?.errors
              ?.length > GlobalConfiguration.lengthCheckZero
          ) {
            errorMessage =
              payload.errors.base[
                GlobalConfiguration.lengthCheckZero
              ].errors.join(", ");
            payload.errors.base[
              GlobalConfiguration.lengthCheckZero
            ].errors.forEach((msg) =>
              setTimeout(
                () =>
                  CommonToast({
                    text: msg,
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  }),
                IntervalConfiguration.intervalExtraLarger,
              ),
            );
          }

          return {
            ...item,
            lifecycle_status:
              isSuccess && item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && payload.status === false
                ? "true"
                : item.error,
            message:
              isReject && isSuccess && isLifecycleMatch
                ? reason
                : !isReject && item.message === "" && payload.status === false
                  ? errorMessage
                  : item.message,
            rejection_reason:
              isReject && isSuccess && isLifecycleMatch
                ? txn?.rejection_reason
                : item.rejection_reason,
            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              isSuccess &&
              loginid.employees.id === txn?.last_updated_user_id
                ? "true"
                : item.last_updated_user_id_check,
          };
        }
        return item;
      });

      setFormatedData(updatedData);
    }

    setTimeout(() => {
      setLoading((prev) => ({ ...prev, [id]: false }));
      setActionLoading(false);
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (
        payload?.status === true &&
        payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status === lifecycleStatus
      ) {
        CommonToast({
          text: `Schedule ${isReject ? "rejected" : "approved"} successfully`,
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      if (payload?.status === errorcode.errorNotFound) {
        CommonToast({
          text: payload?.error,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);

    if (isReject) setShowRejectPopup(false);
    setApproveRejectBtnClicked((prev) => ({ ...prev, [id]: "none" }));
  };

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      CommonToast({
        text: "Refreshing balance",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, GlobalConfiguration.inputMaxLength);
    }
  }, [ownerAccBalanceLoading]);

  const handleRefresh = async (e, id, prevBalance) => {
    e.stopPropagation();
    setrefreshAnimation(id);
    setPrevBalance(prevBalance);
    try {
      let response = await dispatch(getOwnerAccBalance(id));

      if (response?.payload?.status === true) {
        let data = formatedData?.map((item) => {
          if (
            response?.payload?.owner_accounts[
              GlobalConfiguration.lengthCheckZero
            ]?.owner_account_id === item?.owner_account_id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response?.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response?.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_balance,
              owner_account_balance_last_fetched_at:
                response?.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });
        setFormatedData(data);
        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          dispatch(setshowsuccestoast());
        }, PaginationConfiguration.paginationMid);
      } else {
        toast.dismiss();
        CommonToast({
          text:
            response?.payload?.response?.data?.errors?.base[
              GlobalConfiguration.lengthCheckZero
            ] || "Error refreshing balance",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  };

  const handleOpenOccurrence = async (
    transaction_start_date,
    transaction_end_date,
    frequency,
  ) => {
    try {
      const response = await dispatch(
        scheduleInternalTxnOccurrences({
          frequency,
          transaction_start_date,
          transaction_end_date,
          services,
          navigate,
        }),
      );
      setOccurrenceData(response.payload);
      setOpenOccurrencePopup(true);
    } catch (error) {
      console.error("Error fetching occurrences:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (value) => {
    setSelectedPageValue(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne || currentPage);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailPopOpen(!internalAccDetailPopOpen);
  };

  const closeScheduleInternalTxnModal = () => {
    setIsAdditionalPopupOpen("");
  };

  const handleFrequencyMethod = (selectedSettlement) => {
    const value = selectedSettlement.toLowerCase().replace(/ /g, "_");
    setFrequencyMethodfilter(value);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setPaymentMethodFilter(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const handleStartDateMethod = (selectedSettlement) => {
    setStartDateFilter(selectedSettlement);
  };

  const handleEndDateMethod = (selectedSettlement) => {
    setEndDateFilter(selectedSettlement);
  };

  const onMount = () => {
    handleAction();
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  useEffect(() => {
    dispatch(enableSwitcher());
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      dispatch(disableSwitcher());
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    onMount();
    setIsFilterApplied(
      !(
        paymentMethodFilter === "" &&
        frequencyMethodfilter === "" &&
        confidentialMethodFilter === "" &&
        ownerAccNo === "" &&
        internalAccNo === "" &&
        startDateFilter === "" &&
        endDateFilter === "" &&
        txnAmountFilter === "" &&
        searchdata === "" &&
        initCategoryFilter === ""
      ),
    );
  }, [
    isAdditionalPopupOpen,
    dispatch,
    selectedPageValue,
    currentPage,
    frequencyMethodfilter,
    startDateFilter,
    internalAccIdFilter,
    paymentMethodFilter,
    ownerAccId,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    initCategoryFilter,
    markerData,
  ]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    frequencyMethodfilter,
    startDateFilter,
    internalAccIdFilter,
    paymentMethodFilter,
    ownerAccId,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
  ]);

  const handleAmountChange = (val) => {
    setTxnAmountFilter(val);
  };
  const FrequencyOptions = [
    "once",
    "daily",
    "weekly",
    "fortnightly",
    "monthly",
    "quarterly",
    "half_yearly",
    "yearly",
  ];

  const formatFrequencyLabel = (value) =>
    typeof value === "string"
      ? value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  const formattedFrequencyOptions = FrequencyOptions.map(formatFrequencyLabel);

  const filterItems = [
    {
      name: "Internal account",
      short_name: "Int. Acc",
      isMulti: false,
      value: internalAccIdFilter,
      displayValue: internalAccNo,
      setValue: (val) => setInternalAccIdFilter(val),
      setDisplayValue: (val) => setInternalAccNo(val),
      isDropdown: true,
      valueType: "string",
      isDisabled: scheduleIntTxnLoading,
    },
    {
      name: "Owner account",
      short_name: "Own. Acc",
      isMulti: false,
      value: ownerAccId,
      displayValue: ownerAccNo,
      setValue: (val) => setOwnerAccId(val),
      setDisplayValue: (val) => setOwnerAccNo(val),
      isDropdown: true,
      valueType: "string",
      isDisabled: scheduleIntTxnLoading,
    },
    {
      name: "Amount",
      short_name: "Amt",
      isMulti: false,
      value: txnAmountFilter,
      setValue: handleAmountChange,
      displayValue: FormatAmount({ price: txnAmountFilter }),
      isDropdown: false,
      valueType: "number",
      isDisabled: scheduleIntTxnLoading,
    },
  ];
  const filters = [
    {
      name: "Schedule start date",
      filterType: "calender",
      variant: "single",
      value: startDateFilter,
      handleChange: handleStartDateMethod,
      startDate: startDateFilter ? new Date(startDateFilter) : null,
      endDate: null,
      isDisabled: false,
      size: "small",
      minDate: new Date(),
      maxDate: null,
    },

    {
      name: "Schedule end date",
      filterType: "calender",
      variant: "single",
      value: endDateFilter,
      handleChange: handleEndDateMethod,
      startDate: endDateFilter ? new Date(endDateFilter) : null,
      endDate: null,
      isDisabled: false,
      size: "small",
      minDate: startDateFilter || new Date(),
      maxDate: null,
    },
    {
      name: "Frequency",
      filterType: "dropdown",
      variant: "single",
      options: formattedFrequencyOptions,
      isSearch: true,
      dropdownPlaceHolder: "Select frequency",
      searchPlaceholder: "Search frequency",
      value: formatFrequencyLabel(frequencyMethodfilter),
      handleChange: handleFrequencyMethod,
      isDisabled: false,
      size: "small",
    },
    {
      name: "Payment method",
      filterType: "dropdown",
      variant: "single",
      options: ["NEFT", "RTGS"],
      dropdownPlaceHolder: "Select type",
      value: paymentMethodFilter,
      handleChange: handlePaymentMethod,
      isDisabled: false,
      size: "small",
    },

    {
      name: "Show/hide confidential transactions",
      filterType: "dropdown",
      variant: "single",
      options: ["Show only confidential", "Hide confidential"],
      isSearch: false,
      dropdownPlaceHolder: "Default (all transactions)",
      searchPlaceholder: "",
      value: confidentialMethodFilter,
      handleChange: handleConfidentialMethod,
      isDisabled: false,
      size: "small",
    },
  ];

  const updateAllTxn = (updatedTxn) => {
    setFormatedData(updatedTxn);
  };

  const NoAccountRemain =
    "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg";

  const NoTxnFound =
    "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg";
  const isSearchClearAllDisabled = !filterItems?.some(
    (f) => String(f?.value)?.length,
  );

  const isFilterClearAllDisabled = !filters?.some((f) =>
    Array.isArray(f?.value) ? f.value.length : Boolean(f?.value),
  );
  return (
    <>
      {openOccurrencePopup && (
        <div
          style={{ zIndex: "var(--z-index-max)" }}
          className="fixed top-top-base left-left-base w-full h-full "
        >
          <ScheduleTxnOccurrencesPopup
            closeCallback={() => setOpenOccurrencePopup(false)}
            occurrences={occurrenceData?.dates || []}
          />
        </div>
      )}

      {showRejectPopup && (
        <InternalScheduleTxnDeclinePopup
          allTxnData={formatedData}
          handleClose={() => {
            setShowRejectPopup(false);
            setApproveRejectBtnClicked({
              ...approveRejectBtnClicked,
              [scheduleId]: "none",
            });
          }}
          txnId={scheduleId}
          updateAllTxn={updateAllTxn}
          toastType="singleSchedule"
        />
      )}

      {internalAccDetailPopOpen && internalAccId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccDetailsPopUp
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccId}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      {isAdditionalPopupOpen !== "" && internalScheduleId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleInternalTxnDetailPopup
            closeScheduleInternalTxnModal={closeScheduleInternalTxnModal}
            schedule_internaltxn_id={internalScheduleId}
            detailSelected={isAdditionalPopupOpen}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      <div
        className={`w-width-full flex flex-col ${
          !schedulesInternalTxnViewAllLoading &&
          !scheduleIntTxnLoading &&
          formatedData?.length === GlobalConfiguration.lengthCheckOne
            ? "h-screen overflow-hidden"
            : " h-screen overflow-hidden"
        } ${showInnerSearchBar ? "bg-PopUp-BackDrop" : ""}`}
      >
        <></>
        <div className="Qsmd:h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <div className="w-full bg-primary-nav relative z-z-index-header ">
          <div className="w-full z-z-index-header opacity-base-opacity">
            <div className="schedule-int-nav-bar-mob w-full flex flex-row-reverse items-end Qlg:px-padding-base ">
              <TopNavComponent
                filteredSearchProps={{
                  onSearchInput: handleSearch,
                  searchInputRef: filterRef,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search internal schedule",
                  isSearchDisabled: loading || scheduleIntTxnLoading,
                  filterItems: filterItems,
                  filterPlaceholder: "All Fields",
                  loading: scheduleIntTxnLoading,
                  inputData: inputData,
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  isShowFilter: true,
                  filters: filters,
                  isFilterClearAllDisabled: isFilterClearAllDisabled,
                  isSearchClearAllDisabled: isSearchClearAllDisabled,
                  active: active,
                  setActive: setActive,
                }}
                BottomHeader="Schedule Approval Process"
                BottomSubText="Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
                iconComponentArray={[]}
                assignLabelProps={null}
                assignTagProps={null}
                toggleProps={{
                  handleClick: () => {
                    navigate(
                      "/internal_transaction_dashboard/schedule_multi_approval",
                    );
                    setToggle(true);
                  },
                  title: "Multi Approval",
                  state: true,
                }}
                isSelectionView={false}
                selectionText={null}
                selectionBtnProps={null}
                handleBack={() => navigate(GlobalConfiguration.navigate_back)}
              />
            </div>
          </div>
        </div>
        <div
          className={`justify-center items-center  pb-padding-xl h-full overflow-y-auto overflow-x-hidden flex-1 ${
            isFilterApplied ? "internal-schcdule-main-div-con" : ""
          } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity" : ""}`}
        >
          <div
            className={`w-full pt-padding-md  ${showInnerSearchBar ? "overflow-y-hidden bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none" : ""}  Qsmd:pb-padding-md h-full`}
          >
            {formatedData?.length > GlobalConfiguration.lengthCheckZero &&
            !schedulesInternalTxnViewAllLoading &&
            !scheduleIntTxnLoading ? (
              <div
                className={`flex flex-col gap-gap-md items-center xs:pb-medium-screen-top-padding px-padding-md Qsm:!pb-padding-md`}
              >
                {(() => {
                  const uniqueFormatedData =
                    formatedData?.filter(
                      (data, index, self) =>
                        index ===
                        self.findIndex((d) => d.txn_id === data.txn_id),
                    ) || [];

                  return uniqueFormatedData.map((data, index) =>
                    data ? (
                      <div
                        key={data.txn_id || index}
                        className={`w-width-full Qlg:flex Qlg:justify-center z-z-index-base relative ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity" : ""}`}
                      >
                        {" "}
                        {(() => {
                          const amountFormatted = (() => {
                            const amount = Number(data?.amount);

                            if (!amount) return "INR 0.00";

                            return `INR ${new Intl.NumberFormat("en-IN", {
                              minimumFractionDigits:
                                GlobalConfiguration.lengthCheckTwo,
                              maximumFractionDigits:
                                GlobalConfiguration.lengthCheckTwo,
                            }).format(amount)}`;
                          })();

                          const scheduleNameFormatted =
                            data?.scheduled_name
                              ?.toLowerCase()
                              ?.split(" ")
                              ?.map(
                                (word) =>
                                  word
                                    .charAt(GlobalConfiguration.lengthCheckZero)
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration.lengthCheckOne,
                                  ),
                              )
                              ?.join(" ") || "";

                          const createdOnFormatted = `${BeneTxnDataFormat(data?.created_on) || ""}, ${formatTime(data?.last_updated_timestamp || "", false) || ""}`;

                          const transactionPeriodFormatted = `${formatedTxnPeriod(data?.transaction_start_date || "")} - ${formatedTxnPeriod(data?.transaction_end_date || "")}`;

                          const freq = data?.frequency?.toLowerCase();
                          const formattedFreq =
                            freq === "half_yearly"
                              ? "Half yearly"
                              : freq
                                  ?.charAt(GlobalConfiguration.lengthCheckZero)
                                  .toUpperCase() +
                                freq?.slice(GlobalConfiguration.lengthCheckOne);
                          const frequencyFormatted = formattedFreq;

                          const occurrencesOnClick = services?.includes(
                            "ICScheduledTxn",
                          )
                            ? () =>
                                handleOpenOccurrence(
                                  data?.transaction_start_date,
                                  data?.transaction_end_date,
                                  data?.frequency,
                                )
                            : () =>
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "ICScheduledTxn",
                                  },
                                });

                          const additionalDetailsOnClick = () => {
                            setInternalScheduleId(data?.txn_id);
                            setIsAdditionalPopupOpen("Additional details");
                          };

                          const overlay1CtaOnClick = () => {
                            if (
                              data?.lifecycle_status === "pending" &&
                              data?.internal_account_approval_status ===
                                "pending"
                            ) {
                              if (services?.includes("IVAccount")) {
                                setInternalAccDetailPopOpen(true);
                                setInternalAccId(data?.internal_account_id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "IVAccount",
                                  },
                                });
                              }
                            } else {
                              setInternalScheduleId(data?.txn_id);
                              setIsAdditionalPopupOpen("Details");
                            }
                          };

                          const ownerAccountBalanceRaw =
                            data?.owner_account_balance !== undefined
                              ? data?.owner_account_balance
                              : "0";

                          const ownerAccountBalanceOnClick = (e) => {
                            if (services?.includes("VAccountBalance")) {
                              SetrefreshId(data?.txn_id);
                              handleRefresh(
                                e,
                                data?.owner_account_id,
                                data?.owner_account_balance,
                              );
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "VAccountBalance",
                                },
                              });
                            }
                          };

                          const approveClick = () => {
                            setApproveRejectBtnClicked({
                              ...approveRejectBtnClicked,
                              [data?.txn_id]: "approve",
                            });
                            handleTxnAction(data?.txn_id);
                          };

                          const rejectClick = () => {
                            setApproveRejectBtnClicked({
                              ...approveRejectBtnClicked,
                              [data?.txn_id]: "reject",
                            });
                            setScheduleId(data?.txn_id);
                            setShowRejectPopup(true);
                          };

                          const cardState =
                            data?.lifecycle_status === "rejected"
                              ? "double"
                              : (data?.lifecycle_status === "pending" &&
                                    data?.internal_account_approval_status ===
                                      "pending") ||
                                  data?.lifecycle_status === "approved" ||
                                  (data?.lifecycle_status === "error" &&
                                    data?.error === "true")
                                ? "single"
                                : "default";

                          const overlay1Text =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status === "pending"
                              ? "Account approval pending"
                              : data?.lifecycle_status === "approved"
                                ? "Approved"
                                : data?.lifecycle_status === "error" &&
                                    data?.error === "true"
                                  ? "Failed to take action"
                                  : data?.lifecycle_status === "rejected"
                                    ? "Rejected"
                                    : "Unknown error";

                          const overlay1Subtext =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status === "pending"
                              ? "Account is not approved, please approve account before approving transaction."
                              : data?.lifecycle_status === "approved"
                                ? "This schedule has been approved."
                                : data?.lifecycle_status === "error" &&
                                    data?.error === "true"
                                  ? "Unable to retrieve the schedule status. Try refreshing the page."
                                  : data?.lifecycle_status === "rejected"
                                    ? "This schedule has been rejected!"
                                    : "An error occurred while taking action on this schedule.";

                          const overlay1Icon =
                            data?.lifecycle_status === "approved"
                              ? ApprovalGreen
                              : data?.lifecycle_status === "error" &&
                                  data?.error === "true"
                                ? FailedToAction
                                : data?.lifecycle_status === "rejected"
                                  ? DeclinedRed
                                  : undefined;

                          const overlay1IconColor =
                            data?.lifecycle_status === "approved"
                              ? undefined
                              : data?.lifecycle_status === "error" &&
                                  data?.error === "true"
                                ? undefined
                                : data?.lifecycle_status === "rejected"
                                  ? undefined
                                  : undefined;

                          const overlay1CtaText =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status === "pending"
                              ? "Approve account"
                              : "View schedule";

                          const accountApprovalPending =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status ===
                              "pending";

                          return (
                            <div className={``}>
                              <CommonTransactionApprovalCard
                                overrideAutoLoader
                                whichBtnClicked={
                                  approveRejectBtnClicked?.[data?.txn_id] ??
                                  "none"
                                }
                                entries={[
                                  [
                                    {
                                      type: "textSubtext",
                                      text: amountFormatted,
                                      textColor: "var(--settled)",
                                      subText: "Transaction amount",
                                      icon: InternalIcon,
                                      iconColor: "",
                                      isBold: true,
                                      fontSize: "font-sm",
                                    },
                                    {
                                      type: "textSubtext",
                                      text: scheduleNameFormatted,
                                      subText: "Schedule name",
                                      icon:
                                        data?.confidential_transaction === "Y"
                                          ? ConfidentialIcon
                                          : undefined,
                                      iconColor: "",
                                    },
                                    {
                                      type: "textSubtext",
                                      text: createdOnFormatted,
                                      subText: "Created on",
                                    },
                                  ],
                                  [
                                    {
                                      type: "textSubtext",
                                      text: transactionPeriodFormatted,
                                      subText: "Transaction period",
                                    },
                                    {
                                      type: "textSubtext",
                                      text: frequencyFormatted,
                                      subText: "Frequency",
                                    },
                                    {
                                      subText: "Occurrences",
                                      text: data?.occurrences || "",
                                      type: "text",
                                      onClick: occurrencesOnClick,
                                      isDisabled: !hasOccurrenceService,
                                    },
                                  ],
                                ]}
                                approveClick={
                                  cardState === "default"
                                    ? approveClick
                                    : undefined
                                }
                                rejectClick={
                                  cardState === "default"
                                    ? rejectClick
                                    : undefined
                                }
                                ctaBtn1Text="Additional details"
                                ctaBtn1OnClick={additionalDetailsOnClick}
                                ctaBtn2Text={undefined}
                                ctaBtn2OnClick={undefined}
                                alerts={[]}
                                cardState={cardState}
                                ownerAccountNumber={
                                  data?.owner_account_bank_acc_no
                                }
                                ownerAccountIfsc={
                                  data?.owner_account_ifsc_code || ""
                                }
                                ownerAccountNumberSubtext="Source account"
                                ownerAccountBalance={ownerAccountBalanceRaw}
                                ownerAccountBalanceSubtext={`Source account balance - ${data?.owner_account_balance_last_fetched_at_in_words || "Not available"}`}
                                ownerAccountBalanceOnClick={
                                  ownerAccountBalanceOnClick
                                }
                                destinationAccountNumber={
                                  data?.internal_account_bank_acc_no
                                }
                                destinationAccountIfsc={
                                  data?.internal_account_ifsc_code || ""
                                }
                                destinationAccountNumberSubtext="Destination account"
                                destinationAccountText={
                                  data?.internal_account_ifsc_code || ""
                                }
                                destinationAccountSubtext="IFSC code"
                                overlay1CtaDisabled={false}
                                overlay1CtaInactive={false}
                                overlay1CtaLoading={
                                  loading[data?.txn_id] || false
                                }
                                overlay1CtaOnClick={overlay1CtaOnClick}
                                overlay1CtaText={overlay1CtaText}
                                overlay1Text={overlay1Text}
                                overlay1Subtext={overlay1Subtext}
                                overlay1SubtextColor={
                                  data?.lifecycle_status === "pending" &&
                                  data?.internal_account_approval_status ===
                                    "pending"
                                    ? "var(--pending)"
                                    : "var(--text-primary)"
                                }
                                overlay1Icon={overlay1Icon}
                                overlay1IconColor={overlay1IconColor}
                                overlay2Subtext="Rejected reason"
                                overlay2Text={data?.rejection_reason || ""}
                                thisIsARecreateCard={false}
                                recreateOnClick={undefined}
                                recreateBtnText={undefined}
                                rejectBtnText="Reject schedule"
                                approveBtnText="Approve schedule"
                                accountApprovalPending={accountApprovalPending}
                              />
                            </div>
                          );
                        })()}
                      </div>
                    ) : null,
                  );
                })()}
              </div>
            ) : !schedulesInternalTxnViewAllLoading &&
              !scheduleIntTxnLoading &&
              formatedData?.length === GlobalConfiguration.lengthCheckZero ? (
              <div className="w-full h-full flex flex-col justify-center items-center">
                <div className="">
                  <img
                    src={isFilterApplied ? NoTxnFound : NoAccountRemain}
                    alt="NoAccountRemain"
                  />
                </div>
                <div className="w-full mt-margin-md text-text-primary text-font-sm text-center">
                  {isFilterApplied
                    ? "No data found."
                    : "There are no more transactions that require your approval."}
                </div>
                <div className="mt-margin-md">
                  <PrimaryButton
                    btnText={
                      isFilterApplied
                        ? "Clear parameters"
                        : "Internal transaction dashboard"
                    }
                    enabledBgColor="var(--primary-act)"
                    handleFunction={() => {
                      if (isFilterApplied) {
                        setPaymentMethodFilter("");
                        setPaymentMethod("");
                        setFrequencyMethodfilter("");
                        setFrequencyMethod("");
                        setConfidentialMethodFilter("");
                        setConfidentialMethod("");
                        setOwnerAccNo("");
                        setOwnerAccId("");
                        setInternalAccNo("");
                        setInternalAccIdFilter("");
                        setStartDateFilter("");
                        setStartDate("");
                        setEndDateFilter("");
                        setEndDate("");
                        setTxnAmountFilter("");

                        setTxnPayLoad({
                          ...txnPayLoad,
                          ownerAccountId: "",
                          ownerbankAccountNo: "",
                          beneAccountId: "",
                          bankAccountNo: "",
                          amount: "",
                        });
                      } else {
                        navigate("/internal_transaction_dashboard");
                      }
                    }}
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                  />
                </div>
              </div>
            ) : schedulesInternalTxnViewAllLoading && scheduleIntTxnLoading ? (
              <div className="w-full h-[var(--width-almost-full)] flex justify-center items-center">
                <div>
                  <Loader />
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {formatedData.length === GlobalConfiguration.lengthCheckZero ? null : (
          <div className="bottom-bottom-base sticky w-width-full flex items-center justify-center z-z-index-header">
            {showInnerSearchBar && (
              <div className="absolute inset-top-base z-z-index-overlay bg-PopUp-BackDrop opacity-dark-opacity" />
            )}

            <PaginationComponent
              handleSelect={handleChangePageSize}
              selectedValue={selectedPageValue}
              data={transactionData}
              dropdownOptions={PaginationConfiguration.paginationOptions}
              handlePagination={handlePageChange}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ScheduleInternalTransactionSingleApproval;
